import { combineReducers } from "redux";
// Front
import Layout from "./layout/reducer";
// Authentication
import Login from "./auth/login/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
//Order managements
import orders from "./orderManagement/reducer"
//Dbinvoices 
import transactions from './dbInvoices/reducer'
//acount Management 
import service from './servicesManagment/reducer'
//mails
import mails from "./mails/reducer";
//Dashboard 
import Dashboard from "./dashboard/reducer";
//Card
import cartAbandonmentReducer from "./card/cartAbandonmentReducer";

import invoicesReducer from "./invoices/reducer";
import cancellationsReducer from "./cancellations/reducer";
import customerSettlements from "./customerSettlements/reducer";
import providerErpInvoices from "./providerErpInvoices/reducer";
import maintenanceReducer from "./maintenance/reducer";

const rootReducer = combineReducers({
  // public
  cartAbandonment: cartAbandonmentReducer,
  Layout,
  Login,
  ForgetPassword,
  mails,
  Dashboard,
  service,
  transactions,
  orders,
  invoices: invoicesReducer,
  cancellations: cancellationsReducer,
  customerSettlements,
  providerErpInvoices,
  maintenance: maintenanceReducer,

});

export default rootReducer;
